import { rem } from "polished";
import styled from "styled-components";

export const Logo = styled.img`
  height: ${rem("126px")};
  margin-bottom: ${rem("40px")};
`;
